// Shared enum/option definitions for tank sensor advanced settings, used by both
// TankSensorForm.js (create) and sensorEntity.js (view/edit) so the two stay in sync.

export const MAX_STATIC_ALARMS = 3;
export const MAX_DYNAMIC_ALARMS = 2;

export const SAMPLING_PERIOD_OPTIONS = [
    { label: "1 minute", value: 0 },
    { label: "15 minutes", value: 1 },
    { label: "Don't set a period - use logging interval", value: 2 },
];

export const POLLING_INTERVAL_OPTIONS = [
    { label: "Every hour", value: 1 },
    { label: "Every 2 hours", value: 2 },
    { label: "Every 4 hours", value: 4 },
    { label: "Every 6 hours", value: 6 },
    { label: "Every 8 hours", value: 8 },
    { label: "Every 12 hours", value: 12 },
    { label: "Once per day", value: 24 },
];

export const POLARITY_OPTIONS = [
    { label: "Higher", value: "higher" },
    { label: "Lower", value: "lower" },
];

export const CONNECTION_DAY_OPTIONS = [
    { label: "Monday", value: "mon" },
    { label: "Tuesday", value: "tue" },
    { label: "Wednesday", value: "wed" },
    { label: "Thursday", value: "thu" },
    { label: "Friday", value: "fri" },
    { label: "Saturday", value: "sat" },
    { label: "Sunday", value: "sun" },
];
